module.exports = __webpack_public_path__ + "static/img/pinpai-23.f57897f7.png";